import { Platform } from 'react-native'
import Config from 'APP/Config'
import DeviceInfo from 'APP/Helpers/DeviceInfo'
import { isWeb } from 'APP/Helpers/checkPlatform'

export const getRNVersion = (): string => {
  // TODO(WEB): Implement a web build step that instead sets this to the correct value via env var
  if (isWeb()) {
    return '0.0.0'
  }
  const { major, minor, patch } = Platform.constants.reactNativeVersion
  return `${major}.${minor}.${patch}`
}

export interface AppInfo {
  brand_id: string
  os: string
  rn_version: string
  app_version: string
  app_build_number: string
  device_id: string
  app_name: string
  app_id: string
}

export const appInfo: AppInfo = {
  brand_id: Config.BRAND_ID,
  os: Platform.OS,
  rn_version: getRNVersion(),
  app_version: DeviceInfo.getVersion(),
  app_build_number: DeviceInfo.getBuildNumber(),
  device_id: DeviceInfo.getUniqueId(),
  app_name: DeviceInfo.getApplicationName(),
  app_id: DeviceInfo.getBundleId(),
}
